module.exports = __webpack_public_path__ + "img/header@2x.1d465332.jpg";